export const base = '/person/:id/:subTab?';